<!--
 * @Author: guoyu
 * @Date: 2020-10-12 16:37:10
 * @LastEditors: your name
 * @LastEditTime: 2021-04-14 16:49:58
 * @Description: 一般倒计时 yy/mm/dd/hh/cc/ss
-->
<template>
  <div class="countdown-container">
    <div
      class="time-item year-box"
      v-for="(item, index) in handleNums"
      :class="item.name + '-box'"
      :key="'t' + index"
    >
      <span class="time-num">{{ timeList[index] }}</span>
      <span class="time-unit">{{ item.unit }}</span>
    </div>
  </div>
</template>
<script>
import { raf, cancelRaf } from '../utils/raf';
export default {
  props: {
    type: {
      type: String,
      default: 'dd/hh/mm/ss/ms', // 日/时/分/秒/毫秒
    },
    endTime: {
      type: [String, Number],
      default: 0,
    },
    typeMap: {
      type: Object,
      default: () => {
        return {
          dd: {
            unit: '天',
            val: 86400000,
            extral: '', // 补充位
          },
          hh: {
            unit: '時',
            val: 3600000,
            extral: '0',
          },
          mm: {
            unit: '分',
            val: 60000,
            extral: '0',
          },
          ss: {
            unit: '秒',
            val: 1000,
            extral: '0',
          },
          ms: {
            unit: '毫秒',
            val: 1,
            extral: '',
          },
        };
      },
    },
  },
  data() {
    return {
      stopId: 0,
      timeList: [],
    };
  },
  computed: {
    /**
     * @description: 要展示的计数
     */
    handleNums() {
      const types = this.type.split('/');
      return types
        .filter((item) => {
          return this.typeMap[item];
        })
        .map((item) => {
          return this.typeMap[item];
        });
    },
  },
  watch: {
    endTime() {
      this.startCount();
    },
  },
  methods: {
    getTimes() {
      const nowTime = new Date().getTime();
      let countTime = this.endTime - nowTime;
      const times = [];
      if (countTime <= 0) {
        this.$emit('end');
        cancelRaf(this.stopId);
        countTime = 0;
      }
      this.handleNums.forEach((item, index) => {
        times[index] = (countTime / item.val) | 0;
        times[index] =
          times[index] < 10 ? item.extral + times[index] : times[index];
        countTime = countTime % item.val;
      });
      this.$emit('change', times, this.type)
      return times;
    },
    startCount() {
      if (this.stopId) cancelRaf(this.stopId);
      const animateFn = () => {
        this.stopId = raf(animateFn);
        this.timeList = this.getTimes();
      };
      animateFn();
    },
  },
  created() {
    this.startCount();
  },
  destroyed() {
    cancelRaf(this.stopId);
  },
};
</script>
<style lang="scss" scoped>
.countdown-container {
  display: flex;
}
.time-item {
  display: flex;
  align-items: center;
  margin-right: 8px;
  white-space: nowrap;
  &:last-child {
    margin-right: 0;
  }
}
</style>
